// PAYMENT_ADVICE_SYSTEM get
export const PAYMENT_ADVICE_SYSTEM_REQUEST = "PAYMENT_ADVICE_SYSTEM_REQUEST";
export const PAYMENT_ADVICE_SYSTEM_SUCCESS = "PAYMENT_ADVICE_SYSTEM_SUCCESS";
export const PAYMENT_ADVICE_SYSTEM_FAIL = "PAYMENT_ADVICE_SYSTEM_FAIL";

export const PAYMENT_ADVICE_SYSTEM_CLEAR_ERROR = "PAYMENT_ADVICE_SYSTEM_CLEAR_ERROR"